/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as React from 'react';

export interface IAddressWarning {
    message?: string;
}

export const createAddressWarning = (message?: string) => {
    return (
        <span className='msc-address-form__warning alert-warning' role='alert' aria-live='assertive'>
            {message || ''}
        </span>
    );
};
